export default __webpack_public_path__ + "static/howwork2-73d5ace33bef401f8b10be8b541f1f09.jpg";